<template>
  <div class="container-fluid" style="padding: 30px 0; max-width: 1500px">
    <div class="row">
      <div class="col-12">
        <h1 class="text-center">Pedidos</h1>
        <a
          class="pull-right"
          href="https://pedidos.ticketapp.cl/eiensushihualpen"
          target="_blank"
          rel="noopener noreferrer"
          >abrir en otra ventana</a
        >
        <hr />
      </div>

      <div class="col-12">
        <iframe
          class=""
          style="border: 0px"
          src="https://pedidos.ticketapp.cl/eiensushihualpen?header=0&footer=0"
          width="100%"
          height="2000px"
          @load="resizeIframe"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reservas",
  data() {
    return {
      loading: false,
      success: false,
    };
  },
  methods: {
    resizeIframe() {
      let obj = document.querySelector('iframe')
      
        obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
    
    },
  },
  computed: {},
};
</script>
